import { Button } from "@/components/ui/button"
import { HugeiconsIcon } from "@hugeicons/react"
import { Chat01Icon } from "@hugeicons/core-free-icons"
import { useFeatureFlag } from "@/features/feature-flags/hooks/use-feature-flag"
import { useChatPanel } from "../hooks/use-chat-panel"

export function ChatIconButton() {
  const toggle = useChatPanel((s) => s.toggle)
  const enabled = useFeatureFlag("ai_assistant")

  if (!enabled) return null

  return (
    <Button
      variant="ghost"
      size="icon"
      className="cursor-pointer"
      onClick={toggle}
      title="AI Assistant"
    >
      <HugeiconsIcon icon={Chat01Icon} size={32} />
    </Button>
  )
}
